<section id="intro-consulting" class="section-bg-dark">
  <div class="container-fluid">
    <div class="row">
      <div class="col-xs-12 pl-5">
        <h2 class="text-white">CONSULTORÍA TECNOLÓGICA</h2>
      </div>
    </div>
  </div>
</section>

<section id="consulting_services">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 d-none d-sm-none d-md-none d-lg-block">
        <img class="img-resp" src="assets/img/tech-consulting.webp" alt="">
      </div>
      <div class="col-lg-5 col-md-12">
        <div class="row">
          <div class="col-xs-12">
            <p class="font-medium">
              Elaboramos amplias investigaciones
              de mercado en el ámbito digital
              para ofrecer a nuestros clientes
              soluciones de calidad basadas en el
              conocimiento del mercado actual.
            </p>
          </div>
          <div class="col-xs-12">
            <p class="font-medium">
              Ponemos a disposición del cliente un
              servicio de consultoría personalizado y
              adaptado a sus necesidades siempre
              fundamentándose en las investigaciones
              que realizan nuestros consultores.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="container">

      <div class="row p-2">
        <div class="col-xs-12 w-100 text-center p-4">
          <h2>SERVICIO DE CONSULTORÍA</h2>
        </div>
      </div>

    </div>

    <div class="row justify-content-center">
      @for (section of sections; track section) {
      <div class="card col-sm-12 col-md-4 text-center p-2 mt-3">
        <div class="card-body">
          <div class="border_box">

            <h5>{{ section.title }}</h5>
            <p>{{ section.description }}</p>
          </div>
        </div>
      </div>
      }
    </div>

  </div>
</section>